import React, { useEffect, useRef, useState } from 'react';

const ArrowIcon = ({ open }) => (

    <svg className={`category-select-arrow ${open ? 'open' : ''}`} viewBox="64 64 896 896" focusable="false" data-icon="down" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"></path></svg>
    // <svg className={`category-select-arrow ${open ? 'open' : ''}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M7 10l5 5 5-5z" />
    // </svg>
);

const CategorySelect = ({ value, options, onChange }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selected = options.find(o => o.value === value);

    return (
        <div className="category-select" ref={rootRef}>
            <button
                type="button"
                className={`category-select-trigger ${open ? 'open' : ''}`}
                onClick={() => setOpen(o => !o)}
            >
                <span>{selected?.label}</span>
                <ArrowIcon open={open} />
            </button>
            {open && (
                <ul className="category-select-panel" role="listbox">
                    {options.map(opt => (
                        <li
                            key={opt.value}
                            role="option"
                            aria-selected={opt.value === value}
                            className={`category-select-option ${opt.value === value ? 'selected' : ''}`}
                            onClick={() => {
                                onChange(opt.value);
                                setOpen(false);
                            }}
                        >
                            {opt.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CategorySelect;
